import { useEffect } from 'react';
import { usePageRouting } from '@honeycomb/data';
import { addRouterEventListener } from '@honeycomb/routing';
import { trackPageViewClient } from '@honeycomb/tracking';
export function RoutingEffect() {
    const { setIsPageRoutingState } = usePageRouting();
    useEffect(() => {
        const handleRouteChangeStart = () => {
            setIsPageRoutingState(true);
        };
        const handleRouteChangeComplete = (url) => {
            trackPageViewClient(url);
            setIsPageRoutingState(false);
        };
        const handleRouteChangeError = () => {
            setIsPageRoutingState(false);
        };
        addRouterEventListener('routeChangeStart', handleRouteChangeStart);
        addRouterEventListener('routeChangeComplete', handleRouteChangeComplete);
        addRouterEventListener('routeChangeError', handleRouteChangeError);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
}
